import apiClient from '../../../shared/api/client';

export const getPacientes = async () => {
  const { data } = await apiClient.get('/pacientes');
  return data;
};

export const searchPacientesByName = async (nombre) => {
  const { data } = await apiClient.get('/pacientes/v2', { params: { nombre, pageSize: 10 } });
  return data.data;
};

export const getPacientesActivos = async () => {
  const { data } = await apiClient.get('/pacientes/actives');
  return data;
};

export const getPacienteInformeById = async (idPaciente) => {
  const { data } = await apiClient.get(`/pacientes/informes/${idPaciente}`);
  return data;
};

export const getEntrevistasByPaciente = async (idPaciente) => {
  const { data } = await apiClient.get(`/entrevistas/${idPaciente}`);
  return data;
};

export const createPaciente = async (payload) => {
  const { data } = await apiClient.post('/pacientes', payload);
  return data;
};

export const updatePaciente = async ({ idPaciente, payload }) => {
  const { data } = await apiClient.put(`/pacientes/${idPaciente}`, payload);
  return data;
};

export const deletePaciente = async (idPaciente) => {
  const { data } = await apiClient.delete(`/pacientes/${idPaciente}`);
  return data;
};

export const activatePaciente = async (idPaciente) => {
  const { data } = await apiClient.put(`/pacientes/activate/${idPaciente}`);
  return data;
};

export const exportPacientesExcel = async (params) => {
  const response = await apiClient.get('/pacientes/export/xlsx', {
    params,
    responseType: 'blob',
  });
  return response;
};

export const exportPacientesExcelDynamic = async (config) => {
  const response = await apiClient.post('/pacientes/export/xlsx/dynamic', config, {
    responseType: 'blob',
  });
  return response;
};
